import {AnyEvent, JOB_COMPANY_CREATED_EVENT, JobCompanyCreatedEvent} from '../type';

export default function jobCompanyCreated(payload: JobCompanyCreatedEvent['payload']): AnyEvent {
  return {
    type: JOB_COMPANY_CREATED_EVENT,
    payload,
  }
}